import { Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { RootActions } from '../store/reducers';

const useTypedDispatch = () => useDispatch<Dispatch<RootActions>>();

export type AppDispatch = ReturnType<typeof useTypedDispatch>;

export default useTypedDispatch;

